import React, { useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import CleaningVsDetailing from "@/components/CleaningVsDetailing";
import WhatAscendiaSees from "@/components/WhatAscendiaSees";

// Merged, interactive "The Ascendia Difference" section.
// Composes the two existing premium experiences behind a single tabbed control
// so the homepage tells one cohesive story without losing any functionality.
const TABS = [
  { key: "compare", label: "Cleaning vs Detailing", sub: "See the difference, area by area." },
  { key: "details", label: "The Details We See", sub: "The points ordinary cleaning misses." },
];

export const TheAscendiaDifference = () => {
  const [tab, setTab] = useState("compare");
  const reduce = useReducedMotion();
  const activeSub = TABS.find((t) => t.key === tab)?.sub;

  return (
    <div data-testid="the-ascendia-difference">
      <div className="flex justify-center">
        <div className="relative inline-flex rounded-xl border border-[color:var(--border-subtle)] bg-white/[0.03] p-1" role="tablist" aria-label="The Ascendia Difference views">
          {TABS.map((t) => {
            const on = tab === t.key;
            return (
              <button
                key={t.key}
                role="tab"
                aria-selected={on}
                data-testid={`difference-tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`relative rounded-lg px-4 sm:px-5 py-2 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring)] ${on ? "text-black" : "text-white/60 hover:text-white"}`}
              >
                {on && (
                  <motion.span
                    layoutId={reduce ? undefined : "differenceTabPill"}
                    className="absolute inset-0 rounded-lg bg-gold"
                    transition={{ type: "spring", stiffness: 380, damping: 32 }}
                  />
                )}
                <span className="relative">{t.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <AnimatePresence mode="wait">
        <motion.p
          key={`sub-${tab}`}
          initial={reduce ? false : { opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: reduce ? 0 : 0.18 }}
          className="mt-4 text-center text-sm text-muted-c"
        >
          {activeSub}
        </motion.p>
      </AnimatePresence>

      <div className="mt-10">
        <AnimatePresence mode="wait">
          <motion.div
            key={tab}
            initial={reduce ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduce ? { opacity: 0 } : { opacity: 0, y: -8 }}
            transition={{ duration: reduce ? 0 : 0.22 }}
          >
            {tab === "compare" ? <CleaningVsDetailing /> : <WhatAscendiaSees />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default TheAscendiaDifference;
